import logger from "src/utils/logger";
import { SelfieProcessHandler } from "./baseHandler";
import { applicationStore } from "src/store/ApplicationStore";
import { workflowStepIterator } from "src/services/workflowStepIterator";
import { LivenessImageMovementPayloadValues } from "src/enums/LivenessImageMovementPayloadValues";
import { NodeTypes } from "src/enums/NodeTypes";
import { parseServiceErrorMessage } from "src/helpers/parseServiceError";

export class SelfieOnlyHandler extends SelfieProcessHandler {
    constructor(navigateFn) {
        super();
        this.navigate = navigateFn;
    }

    async handle(image) {
        try {
            const response = await workflowStepIterator({
                access_token: applicationStore.access_token,
                node_id: applicationStore.workflowNextServiceResponse.node_id,
                body: {
                    "data": [
                        {
                            image,
                            movement_payload: LivenessImageMovementPayloadValues.MATCH
                        }
                    ]
                },
                action_index: applicationStore.workflowNextServiceResponse.index,
                constextOfStep: { step: NodeTypes.VERIFICATION, "retry": applicationStore.workflowNextServiceResponse.retry }
            })
            if (response.data?.service_results[0].status !== 200) {
                const rawMessage = response.data?.service_results[0]?.message;
                const parsedMessage = parseServiceErrorMessage(rawMessage);
                throw new Error(parsedMessage);
            }
            applicationStore.setWorkflowNextServiceResponse(response.data);

            this.navigate("/next", { replace: true });
        } catch (error) {
            throw error;
        }
    }
}